/** @format */

import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Component, HostListener, Inject, Input, OnInit, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DeviceService, Scene7Service, TaggingService } from '@shared/data-access/services';
import { BreakPoint } from '@shared/data-access/enums';
import { HomrDataService, HomrPage } from '@shared/homr/data-access';
import { Subscription } from 'rxjs';

@Component({
	selector: 'clp-category-header-with-deals',
	templateUrl: './category-header_deals.component.html',
	styleUrl: './category-header.component.scss',
	standalone: false
})
export class CategoryHeaderWithDealsComponent implements OnInit {
	@Input()
	public categoryData: any;

	@Input()
	public homrContent: any;

	public isMobile = false;
	public isTablet = false;
	public categoriesDataStore = [];
	public activeCategorySubscription: Subscription;
	public createTag = TaggingService.createSimpleTag;
	public createDealTag = TaggingService.createDealDrawerTag;

	private readonly DEALDRAWER = {
		pageType: 'deal-drawer',
		contentType: 'Deal Drawer'
	};

	public activeDeals: any[];
	public activeDealsHovered = false;
	public activeTabIndex: number;

	/**
	 * @description
	 * The array of seoTokens
	 *
	 * @type {array}
	 */
	public subcategorySeoTokens: any = [];

	constructor(
		@Inject(PLATFORM_ID) protected platformId: any,
		@Inject(DOCUMENT) private readonly document: any,
		private readonly route: ActivatedRoute,
		private readonly scene7UrlService: Scene7Service,
		private readonly deviceService: DeviceService,
		private readonly homrDataService: HomrDataService
	) {}

	scene7service(imageName: string) {
		return this.scene7UrlService.scene7Url(imageName);
	}

	ngOnInit() {
		if (isPlatformBrowser(this.platformId)) {
			// Check the breakpoint
			this.onResize();

			const deals = this.route.snapshot.queryParams['deal'];
			if (this.homrContent[this.DEALDRAWER.contentType] && deals) {
				this.autoOpen(deals);
			}
		}
	}

	public autoOpen(linkName) {
		const index = this.homrContent[this.DEALDRAWER.contentType].findIndex(
			(drawer) => drawer.autoOpenLinkName === linkName
		);
		this.categoryClick(null, index);
	}

	/**
	 * @description
	 * Function to handle the click on Category
	 *
	 * @param index
	 */
	public categoryClick(event?, index?) {
		// Active Category
		if (this.homrContent[this.DEALDRAWER.contentType]) {
			if (
				typeof this.homrContent?.[this.DEALDRAWER.contentType]?.[index]?.deals ===
				'undefined'
			) {
				this.homrDataService
					.getData$(
						this.DEALDRAWER.pageType,
						3,
						this.homrContent[this.DEALDRAWER.contentType][index].drawerPageName
					)
					.subscribe((deals: HomrPage) => {
						if (deals?.content) {
							this.homrContent[this.DEALDRAWER.contentType][index].deals =
								deals.content['Deal'];
							this.homrContent[this.DEALDRAWER.contentType][index].deals.forEach(
								(deal) => {
									deal.em = `LN_${
										this.homrContent[this.DEALDRAWER.contentType][index].message
									}_${deal.message}`;
								}
							);
							this.homrContent[this.DEALDRAWER.contentType].forEach((drawer, ind) => {
								if (index === ind) {
									drawer.panelOpenState = true;
								} else {
									drawer.panelOpenState = false;
								}
							});
						}
					});
			}
		}
	}

	/**
	 * @param event - Event
	 * @param searchTerm - The entered search term
	 *
	 * @description
	 * Function called on Category keyup
	 */
	public categoryKeyUp(event, index) {
		if (event.keyCode === 13) {
			this.categoryClick(event, index);
		}
	}

	public togglebodyClass(panel) {
		if (panel.panelOpenState === true) {
			// Add body class to prevent body scrolling
			this.document.body.classList.add('overflow-hidden');
		} else {
			// Remove body class to prevent
			this.document.body.classList.remove('overflow-hidden');
		}
	}
	@HostListener('window:resize', ['$event'])
	public onResize() {
		// Check the breakpoint
		if (
			this.deviceService.getDeviceBreakPoint() === BreakPoint.EXTRASMALL ||
			this.deviceService.getDeviceBreakPoint() === BreakPoint.SMALL
		) {
			this.isMobile = true;
			this.isTablet = false;
		} else if (this.deviceService.getDeviceBreakPoint() === BreakPoint.MEDIUM) {
			this.isTablet = false;
			this.isMobile = true;
		} else {
			this.isMobile = false;
			this.isTablet = false;
		}
	}

	// Hide the opened categories on scroll
	public hideCategory(event) {
		if (event.target.scrollTop === event.target.scrollHeight - event.target.offsetHeight) {
			event.currentTarget.classList.remove('opacity');
		} else {
			event.currentTarget.classList.add('opacity');
		}

		this.hideAllSubCategories();
	}

	// Hide category on mouse out
	public hideAllSubCategories() {
		if (this.categoryData?.category) {
			this.categoryData.category.forEach((category) => {
				category.panelOpenState = false;
			});
		}
	}

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	trackByFn(index: number, _item: any): number {
		return index;
	}
}
